import script from "./AudiInstallStatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./AudiInstallStatusView.vue?vue&type=script&setup=true&lang=js"

import "./AudiInstallStatusView.vue?vue&type=style&index=0&id=3ae1797e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae1797e"]])

export default __exports__